module.exports = __webpack_public_path__ + "img/tool2.e8e1d4c.png";